import { render, staticRenderFns } from "./Colors.vue?vue&type=template&id=c93544a6&scoped=true&"
import script from "./Colors.vue?vue&type=script&lang=js&"
export * from "./Colors.vue?vue&type=script&lang=js&"
import style0 from "./Colors.vue?vue&type=style&index=0&id=c93544a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93544a6",
  null
  
)

export default component.exports